import React, { useState, useEffect, useCallback } from 'react';
import useApi from '../hooks/useApi';

const LogsPage = ({ currentUser }) => {
    const { apiFetch } = useApi();
    const [logs, setLogs] = useState([]);
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
    const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
    const [selectedUserId, setSelectedUserId] = useState('');

    const fetchLogs = useCallback(async () => {
        setLoading(true);
        setError('');
        try {
            let url = `/logs?startDate=${startDate}&endDate=${endDate}`;
            if (selectedUserId) {
                url += `&userId=${selectedUserId}`;
            }
            const data = await apiFetch(url);
            setLogs(data);
        } catch (err) {
            setError('Falha ao carregar os logs do sistema.');
        } finally {
            setLoading(false);
        }
    }, [apiFetch, startDate, endDate, selectedUserId]);

    useEffect(() => {
        if (!currentUser) return;
        const fetchInitialData = async () => {
            try {
                const usersData = await apiFetch(`/users?entityId=${currentUser.entityId}`);
                setUsers(usersData);
                fetchLogs();
            } catch(err) {
                setError("Falha ao carregar lista de utilizadores.");
                 setLoading(false);
            }
        };
        fetchInitialData();
    }, [fetchLogs, apiFetch, currentUser]);

    return (
        <div>
            <h1 className="text-3xl font-bold text-gray-800">Logs do Sistema</h1>
            <p className="mb-6 text-gray-600">Auditoria de todas as ações realizadas na aplicação.</p>

            <div className="p-4 mb-6 space-y-4 bg-white rounded-lg shadow md:space-y-0 md:flex md:items-center md:gap-4 flex-wrap">
                <div>
                    <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">Data de Início</label>
                    <input type="date" id="startDate" value={startDate} onChange={e => setStartDate(e.target.value)} className="w-full px-3 py-2 mt-1 border border-gray-300 rounded-md" />
                </div>
                <div>
                    <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">Data de Fim</label>
                    <input type="date" id="endDate" value={endDate} onChange={e => setEndDate(e.target.value)} className="w-full px-3 py-2 mt-1 border border-gray-300 rounded-md" />
                </div>
                <div>
                    <label htmlFor="userFilter" className="block text-sm font-medium text-gray-700">Utilizador</label>
                    <select id="userFilter" value={selectedUserId} onChange={e => setSelectedUserId(e.target.value)} className="w-full px-3 py-2 mt-1 border border-gray-300 rounded-md">
                        <option value="">Todos os Utilizadores</option>
                        {users.map(user => (
                            <option key={user.id} value={user.id}>{user.username}</option>
                        ))}
                    </select>
                </div>
                <button onClick={fetchLogs} className="self-end w-full px-4 py-2 font-semibold text-white bg-blue-600 rounded-md md:w-auto">
                    Filtrar
                </button>
            </div>
            
            {loading && <p>A carregar logs...</p>}
            {error && <p className="text-red-600">{error}</p>}

            {!loading && !error && (
                <div className="overflow-x-auto bg-white rounded-lg shadow">
                    <table className="w-full text-sm text-left text-gray-600">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                            <tr>
                                <th className="px-6 py-3">Data e Hora</th>
                                <th className="px-6 py-3">Utilizador</th>
                                <th className="px-6 py-3">Entidade</th>
                                <th className="px-6 py-3">Ação</th>
                            </tr>
                        </thead>
                        <tbody>
                            {logs.map(log => (
                                <tr key={log.id} className="bg-white border-b hover:bg-gray-50">
                                    <td className="px-6 py-4 whitespace-nowrap">{new Date(log.timestamp.replace(' ', 'T') + 'Z').toLocaleString('pt-BR')}</td>
                                    <td className="px-6 py-4">{log.username || 'N/A'}</td>
                                    <td className="px-6 py-4">{log.entityName || 'N/A'}</td>
                                    <td className="px-6 py-4">{log.action}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default LogsPage;

